import { z } from 'zod';
import { DEVISES } from './model/commun.js';
export const ETATS_OEUVRE_CONFIEE = ['confiee', 'vendue', 'rendue'];
const id = z.string().regex(/^[a-f\d]{24}$/i);
const montant = z.int().positive().max(100_000_000_000);
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const creationOeuvreConfieeSchema = z.strictObject({
    oeuvreId: id,
    deposantId: id,
    mouvementId: id.nullable().default(null),
    recueLe: date.optional(),
    finPrevueLe: date.nullable().default(null),
    prixNetCentimes: montant,
    devise: z.enum(DEVISES),
    note: z.string().trim().max(1000).default(''),
});
export const reglementDeposantSchema = z.strictObject({
    revision: z.int().min(0),
    regleLe: date,
    montantCentimes: montant.optional(),
    reference: z.string().trim().max(120).default(''),
    note: z.string().trim().max(300).default(''),
});
export const annulationReglementDeposantSchema = z.strictObject({
    revision: z.int().min(0),
    motif: z.string().trim().min(1).max(1000),
});
export const retourOeuvreConfieeSchema = z.strictObject({ revision: z.int().min(0) });
export function totauxDeposant(lignes) {
    const totaux = new Map();
    for (const ligne of lignes) {
        const total = totaux.get(ligne.devise) ?? {
            devise: ligne.devise,
            netCentimes: 0,
            duCentimes: 0,
            regleCentimes: 0,
        };
        total.netCentimes += ligne.prixNetCentimes;
        if (ligne.etat === 'vendue' && !ligne.reglement)
            total.duCentimes += ligne.prixNetCentimes;
        total.regleCentimes += ligne.reglement?.montantCentimes ?? 0;
        if (![total.netCentimes, total.duCentimes, total.regleCentimes].every(Number.isSafeInteger))
            throw new Error('Total en centimes hors limite.');
        totaux.set(ligne.devise, total);
    }
    return [...totaux.values()];
}
//# sourceMappingURL=espace-deposant.js.map